import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { isNotEmpty } from "../../Utils";

function Form107SubmittedDialog({ formOpen, onConfirm, referenceNumber = "" }) {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <Dialog aria-labelledby="simple-dialog-title" open={formOpen}>
                <DialogTitle id="simple-dialog-title">
                    {t("common.portal.successfulFormSubmission")}
                </DialogTitle>
                <DialogContent
                    dangerouslySetInnerHTML={{
                        __html: t("Form107.dialog.message"),
                    }}
                ></DialogContent>
                <br />
                <DialogContent>
                    {isNotEmpty(referenceNumber) &&
                        `${t(
                            "common.portal.referenceNum"
                        )}: ${referenceNumber}`}
                </DialogContent>
                <br />
                <DialogActions>
                    <Button autoFocus onClick={onConfirm} color="success">
                        <b>{t("common.portal.confirm")}</b>
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
export default Form107SubmittedDialog;
